import { render, staticRenderFns } from "./_trustId.vue?vue&type=template&id=707cad4a"
import script from "./_trustId.vue?vue&type=script&lang=ts"
export * from "./_trustId.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports